<template>
  <div>
    <div class="home-live" :class="{ 'dark-theme': isDarkTheme }">
    <!-- 直播顶部信息栏 -->
    <div class="live-header">
      <div class="live-info">
        <div class="live-left">
          <img src="@/assets/img/base/WeChat.png" />
          <span>直播中控台</span>
        </div>
        <div class="live-center">
            <span class="live-time">当前直播时间：{{ currentLiveTime }}</span>
            <span class="live-title">2025-12-07 12:00 省直大连线直播</span>
            <span class="live-period">(2025-12-07 12:00:00至2025-12-07 13:00:00)</span>
        </div>
        <div class="live-right">
          <!-- <img src="@/assets/img/base/xl.png" /> -->
          <el-dropdown>
            <span class="el-dropdown-link">
              <img src="@/assets/img/base/WeChat.png" class="logoimg" />
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>账户中心</el-dropdown-item>
              <el-dropdown-item>退出账号</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    
    <!-- 直播主内容区 -->
    <div class="live-main">
      <!-- 左侧用户列表 -->
      <div class="user-list-panel">
        <div class="panel-header">
          <div class="panel-item1" @click="scrollLeft">
            <img src="@/assets/img/base/tableft.png" />
          </div>
          <div class="panel-item2">
            <ul ref="tabUl">
              <li :class="cur==0?'actvie':''" @click="swidths(0)">全部(14362)</li>
              <li :class="cur==1?'actvie':''" @click="swidths(1)">在线(1)</li>
              <li :class="cur==2?'actvie':''" @click="swidths(2)">离线(14361)</li>
              <li :class="cur==3?'actvie':''" @click="swidths(3)">黑名单</li>
              <li :class="cur==4?'actvie':''" @click="swidths(4)">禁言</li>
              <li :class="cur==5?'actvie':''" @click="swidths(5)">屏蔽</li>
            </ul>
          </div>
          <div class="panel-item3" @click="scrollRight">
            <img src="@/assets/img/base/tabright.png" />
          </div>
        </div>
        <div class="search-box">
          <div class="searchxs">
            <div :class="cur1==0?'actvies':''" @click="swidths1(0)">学员(651)</div>
            <div :class="cur1==1?'actvies':''" @click="swidths1(1)">助教(651)</div>
          </div>
          <div class="search-cr">
           <div class="sear-left">
             <div class="searchit">
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-links">
                  用户昵称<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="nickname">用户昵称</el-dropdown-item>
                  <el-dropdown-item command="remark">用户备注</el-dropdown-item>
                  <el-dropdown-item command="userId">用户ID</el-dropdown-item>
                  <el-dropdown-item command="phone">手机号</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
           </div>
            <input class="i-np" placeholder="请输入用户昵称"></input>
            
           </div>
            <img src="@/assets/img/base/sxicon.png" />
          </div>
          <div class="search-cr">
           <div class="sear-left">
             <div class="searchit">
                <el-dropdown @command="handleCommands1">
                  <span class="el-dropdown-links1">
                    {{belonging?belonging:'全部跟进'}}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="全部跟进">全部跟进</el-dropdown-item>
                    <el-dropdown-item command="无归属客户">无归属客户</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
            </div>
            <div class="searchit">
                <el-dropdown @command="handleCommands2">
                  <span class="el-dropdown-links1">
                    {{behavior?behavior:'全部行为'}}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="全部行为">全部行为</el-dropdown-item>
                    <el-dropdown-item command="发言">发言</el-dropdown-item>
                    <el-dropdown-item command="领券">领券</el-dropdown-item>
                    <el-dropdown-item command="点击商品">点击商品</el-dropdown-item>
                    <el-dropdown-item command="下单待支付">下单待支付</el-dropdown-item>
                    <el-dropdown-item command="购买">购买</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
            </div>  
           </div>
            <el-dropdown @command="handleCommands3">
                <span class="el-dropdown-links2">
                  操作
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="0">隐藏标签</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
          </div>
        </div>

        <div class="user-list">
          <div class="user-item" v-for="(user, index) in userList" :key="index">
            <div class="user-avatar">
              <img :src="user.avatar" alt="用户头像">
            </div>
            <div class="user-infos">
               <div class="user-info">
                <div class="user-name">{{ user.name }}</div>
                <div class="user-phone">{{ user.phone }}</div>
                <div class="user-use">消费大于30元的客户</div>
                <div class="tabitem">
                  <span>领券x2</span>
                  <span>点击商品x3</span>
                  <span>购买x1</span>
                </div>
              </div>
            </div>
            <div class="user-actions">
              <el-dropdown trigger="click" @command="handleCommands4">
                  <span class="el-dropdown-links1">
                   <img src="@/assets/img/base/mores.png" class="mores" />
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="index+','+0">贴标签</el-dropdown-item>
                    <el-dropdown-item :command="index+','+1">数据</el-dropdown-item>
                    <el-dropdown-item :command="index+','+2">拉黑</el-dropdown-item>
                    <el-dropdown-item :command="index+','+3">禁言</el-dropdown-item>
                    <el-dropdown-item :command="index+','+4">屏蔽</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
            </div>
          </div>
        </div>
      </div>

      <!-- 中间直播区域 -->
      <div class="live-video-panel">
        <!-- 直播视频 -->
        <div class="video-container">
          <img src="https://images.unsplash.com/photo-1536440136628-849c177e76a1?w=1200&h=675&fit=crop" alt="直播画面" class="video-img">
          <div class="video-overlay">
            <div class="video-title">供销社改革与发展</div>
            <div class="video-subtitle">2025年12月07日 12:00</div>
          </div>
        </div>

        <!-- 直播控制栏 -->
        <div class="video-controls">
            <div class="panel-header">
              <div class="panel-item1" @click="scrollLefts">
                <img src="@/assets/img/base/tableft.png" />
              </div>
              <div class="panel-item2">
                <ul ref="tabUls">
                  <li v-for="(item,index) in navlist" :key="index" v-if="item.checks" :class="cur4==index?'actvie':''" @click="swidths3(index)">
                    <img :src="cur4==index?getImageUrl(item.xzicon):getImageUrl(item.wxicon)"/>
                    <span>{{item.name}}</span>
                  </li>
                </ul>
              </div>
              <div class="panel-item3" @click="scrollRights">
                <img src="@/assets/img/base/tabright.png" />
              </div>
            </div>
            <div class="g_btn">
              <img @click="gshow = !gshow" :src="gshow?getImageUrl('/img/base/gicom2.png'):getImageUrl('/img/base/gicom1.png')"/>
              <span @click="gshow = !gshow" :style="gshow?'color:#2476FD':''">工具箱</span>
              <div class="glist" v-if="gshow">
                <div class="listitem">
                  <span class="spans">直播带货</span>
                  <div class="listitem1">
                    <div class="listitem2" v-for="(item,index) in navlist" :class="cur5==index?'actvie':''" @click="swidths4(index)" v-if="index==11">
                      <div>
                        <img :src="item.checks?getImageUrl(item.xzicon):getImageUrl(item.wxicon)"/>
                         <span :style="item.checks?'color:#2476FD':''">{{item.name}}</span>
                      </div>
                      <img :src="item.checks?getImageUrl('/img/base/xzicon2.png'):getImageUrl('/img/base/xzicon1.png')"/>
                    </div>
                  </div>
                </div>
                <div class="listitem">
                  <span class="spans">营销互动</span>
                  <div class="listitem1">
                    <div class="listitem2" v-for="(item,index) in navlist" :class="cur5==index?'actvie':''" @click="swidths4(index)" v-if="index>5&&index<11">
                      <div>
                        <img :src="item.checks?getImageUrl(item.xzicon):getImageUrl(item.wxicon)"/>
                         <span :style="item.checks?'color:#2476FD':''">{{item.name}}</span>
                      </div>
                      <img :src="item.checks?getImageUrl('/img/base/xzicon2.png'):getImageUrl('/img/base/xzicon1.png')"/>
                    </div>
                  </div>
                </div>
                <div class="listitem">
                  <span class="spans">用户运营</span>
                  <div class="listitem1">
                    <div class="listitem2" v-for="(item,index) in navlist" :class="cur5==index?'actvie':''" @click="swidths4(index)" v-if="index<6">
                      <div>
                        <img :src="item.checks?getImageUrl(item.xzicon):getImageUrl(item.wxicon)"/>
                         <span :style="item.checks?'color:#2476FD':''">{{item.name}}</span>
                      </div>
                      <img :src="item.checks?getImageUrl('/img/base/xzicon2.png'):getImageUrl('/img/base/xzicon1.png')"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>

        <!-- 数据统计区域 -->
        <div class="stats-panel">
          <div class="stats-header">
            <span class="stats-title">观看数据</span>
            <span class="stats-tabs">
              <span class="tab active">实时数据</span>
              <span class="tab">交易数据</span>
              <span class="tab">统计报表</span>
              <span class="tab">本期直播总览</span>
              <select class="time-select">
                <option>今日</option>
                <option>本周</option>
                <option>本月</option>
              </select>
            </span>
          </div>

          <div class="stats-content">
            <div class="stats-cards">
              <div class="stat-card">
                <div class="stat-label">实时在线人数</div>
                <div class="stat-value">1</div>
              </div>
              <div class="stat-card">
                <div class="stat-label">百人数</div>
                <div class="stat-value">2,207</div>
              </div>
              <div class="stat-card">
                <div class="stat-label">直播带货交易额</div>
                <div class="stat-value">28,040.34</div>
              </div>
              <div class="stat-card">
                <div class="stat-label">成交人数</div>
                <div class="stat-value">334</div>
              </div>
              <div class="stat-card">
                <div class="stat-label">成交商品数</div>
                <div class="stat-value">466</div>
              </div>
            </div>

            <!-- 数据图表 -->
            <div class="stats-chart">
              <div class="chart-placeholder">
                <!-- 这里可以集成ECharts等图表库 -->
                <div class="chart-title">在线人数趋势图</div>
                <div class="chart-legend">
                  <span class="legend-item"><i class="legend-dot online"></i>在线</span>
                  <span class="legend-item"><i class="legend-dot bandwidth"></i>带宽</span>
                  <span class="legend-item"><i class="legend-dot pv"></i>PV</span>
                </div>
                <div class="chart-time-range">2025-12-07 12:00:00 至 2025-12-07 13:00:00</div>
                <!-- 模拟图表 -->
                <div class="chart-simulation">
                  <div class="chart-lines">
                    <div class="line line-online"></div>
                    <div class="line line-bandwidth"></div>
                    <div class="line line-pv"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧讨论区 -->
      <div class="discussion-panel">
        <div class="panel-header">
          <span class="panel-title">讨论区</span>
          <div @click="zkshow = !zkshow">
            <img v-if="zkshow==false" src="@/assets/img/base/tlicon1.png" />
            <img v-else src="@/assets/img/base/tlicon2.png" />
          </div>
        </div>

        <div class="discussion-header" v-if="zkshow">
          <div class="panel-headers">
            <div class="panel-item1" @click="scrollLeftr">
              <img src="@/assets/img/base/tableft.png" />
            </div>
            <div class="panel-item2">
              <ul ref="tabUlr">
                <li :class="cur2==0?'actvie':''" @click="swidths2(0)">全部</li>
                <li :class="cur2==1?'actvie':''" @click="swidths2(1)">用户消息</li>
                <li :class="cur2==2?'actvie':''" @click="swidths2(2)">我的用户</li>
                <li :class="cur2==3?'actvie':''" @click="swidths2(3)">讲师</li>
                <li :class="cur2==4?'actvie':''" @click="swidths2(4)">用户消息</li>
                <li :class="cur2==5?'actvie':''" @click="swidths2(5)">我的用户</li>
                <li :class="cur2==6?'actvie':''" @click="swidths2(6)">讲师</li>
              </ul>
            </div>
            <div class="panel-item3" @click="scrollRightr">
              <img src="@/assets/img/base/tabright.png" />
            </div>
          </div>
          <div class="message-filters">
            <label class="filter-item">
              <input type="checkbox"> 只看财富
            </label>
            <label class="filter-item">
              <!-- <input type="checkbox" style="display:none">  -->
              关闭弹幕 
              <el-switch
              v-model="value1">
            </el-switch>
            </label>
          </div>
        </div>
         <!-- @mouseleave="handleLeave(99999999)" -->
        <div class="message-list">
          <div class="message-lists" v-for="(message, index) in messageList" :key="index"  @mouseenter="handleEnter(index)">
            <div class="titme">2025-11-12 15:33:02</div>
            <div class="message-item">
              <div class="message-avatar">
                <img :src="message.avatar" alt="用户头像">
              </div>
              <div class="message-content">
                <div class="message-user-info">
                  <span class="message-username">{{ message.username }}</span>
                </div>
                <div class="message-text">{{ message.content }}</div>
              </div>
            </div>
            <div class="conright" v-if="cur3==index">
              <span>回复</span>
              <span>贴标签</span>
              <span>隐藏</span>
              <span>屏蔽</span>
              <div class="user-actions">
              <el-dropdown trigger="click" placement="top" @command="handleCommands5">
                  <span class="el-dropdown-links1">
                   <img src="@/assets/img/base/mores.png" class="mores" />
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="index+','+0">禁言</el-dropdown-item>
                    <el-dropdown-item :command="index+','+1">置顶</el-dropdown-item>
                    <el-dropdown-item :command="index+','+2">加入提问</el-dropdown-item>
                    <el-dropdown-item :command="index+','+3">拉黑</el-dropdown-item>
                    <el-dropdown-item :command="index+','+4">撤回</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
            </div>
            </div>
          </div>
        </div>

        <div class="message-input-area">
          <div class="top-message">
            <div class="message-left">
              <img src="@/assets/img/base/fsicon1.png" @click="showEmoji = !showEmoji" />
              <img src="@/assets/img/base/fsicon2.png" @click="dialogVisible = !dialogVisible" />
              <img src="@/assets/img/base/fsicon3.png" @click="dialogVisibleadr = !dialogVisibleadr"/>
            </div>
            <el-dropdown trigger="click" placement="top" @command="handleCommands6">
                <div class="message-btn">
                  <img src="@/assets/img/base/fsicon4.png" />
                  <span>操作</span>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="0">
                    <div>
                      <span style="margin-right:20px">全员屏蔽</span>
                       <el-switch @change="qypbbtn"
                        v-model="value2">
                      </el-switch>
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item :command="1">
                    <div>
                      <span style="margin-right:20px">全员禁言</span>
                       <el-switch  @change="qyjybtn"
                        v-model="value3">
                      </el-switch>
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item :command="2">直播间个人信息</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            
          </div>
          <div ref="editor" contenteditable="true" v-html="sedcon" @input="handleInput" @blur="syncContent" aria-placeholder="说点什么呢" role="textbox" aria-multiline="true" class="shopro-send-pre"></div>
          <div class="message-filters">
            <label class="filter-item">
              <input type="checkbox"> 提问
            </label>
            <label class="filter-items">
              发送 
            </label>
          </div>
          <!-- 表情包 -->
          <div class="emoji-box" v-if="showEmoji">
            <div class="emoji-boxs" v-for="(memoji, index) in newEmojiList" :key="index">
                <div class="div u-flex u-col-center">
                  <div class="emoji-img" v-for="(memo, mindex) in memoji" :key="memo.file" @click="onEmoji(memo)">
                    <img class="emoji-img" :src="getImageUrl(`/emoji/${memo.file}`)" mode=""></img>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div style="width:100%;height:600px;background:red;display:flex;justify-content:center;align-items:center"> 
   
  </div>
  <el-dialog
    title="素材库"
    :visible.sync="dialogVisible"
    width="600px"
    :before-close="handleClose">
    <div class="middle-container">
      <div class="middle-container-left">
        <div :class="curnav==0?'actives1':''" @click="tabnav(0)">图片</div>
        <div :class="curnav==1?'actives1':''" @click="tabnav(1)">文件</div>
        <div :class="curnav==2?'actives1':''" @click="tabnav(2)">音频</div>
        <div :class="curnav==3?'actives1':''" @click="tabnav(3)">视频</div>
      </div>
      <div class="middle-container-right">
        <div  class="right-top" v-if="curnav==1"><label  for="uploadFile"
            class="upload-label">
            <input  type="file" id="uploadFile" data-type="file"
              class="right-top-input" @change="handleFileChange($event, 'file')">
              <button  type="button" name="button" class="right-top-upload" @click="triggerFileInput('uploadFile')"> 本地上传 </button></label>
          <p  class="right-top-desc">支持ppt、pdf、excel、word 格式文件，大小不超过 20M</p>
        </div>
        <div  class="right-top"  v-if="curnav==0"><label  class="upload-label">
          <input type="file" accept="image/*" id="uploadImage" data-type="image" class="right-top-input" @change="handleFileChange($event, 'image')"><button
                type="button" name="button" class="right-top-upload" @click="triggerFileInput('uploadImage')"> 本地上传 </button></label>
          <p  class="right-top-desc">支持上传 png，jpg，jpeg，gif 格式，大小不超过10M</p>
        </div>
        <div  class="right-top"  v-if="curnav==2"><label  for="uploadAudio"
            class="upload-label"><input  type="file" accept="audio/*" id="uploadAudio"
              data-type="audio" class="right-top-input" @change="handleFileChange($event, 'audio')"><button  type="button" name="button"
              class="right-top-upload" @click="triggerFileInput('uploadAudio')"> 本地上传 </button></label>
          <p  class="right-top-desc">仅支持上传mp3格式，大小不超过50M</p>
        </div>
        <div  class="right-top"  v-if="curnav==3"><label  for="uploadVideo"
            class="upload-label"><input  type="file" accept="video/*" id="uploadVideo"
              data-type="video" class="right-top-input" @change="handleFileChange($event, 'video')"><button  type="button" name="button"
              class="right-top-upload" @click="triggerFileInput('uploadVideo')"> 本地上传 </button></label>
          <p  class="right-top-desc">仅支持上传mp4格式，大小不超过1G</p>
        </div>
        <!-- <div class="upload-progress" v-if="uploadLoading">
          <el-progress :percentage="uploadProgress" :text-inside="true" :stroke-width="20"></el-progress>
        </div> -->
        <div class="uploaded-list-container">
          <div v-if="uploadList[getCurrentType()].length > 0" class="uploaded-list">
            <div v-for="(file, index) in uploadList[getCurrentType()]" :key="index" class="uploaded-item">
            <div class="file-info">
              <span class="file-name">{{ file.name }}</span>
              <span class="file-size">({{ formatFileSize(file.size) }})</span>
              <!-- 显示音频或视频的时长信息 -->
              <span v-if="file.duration" class="file-duration">({{ file.duration.formatted }})</span>
            </div>
            <div class="file-actions">
              <el-button type="text" size="small" @click="downloadFile(file)">下载</el-button>
              <el-button type="text" size="small" @click="deleteUploadedFile(getCurrentType(), index)">删除</el-button>
            </div>
          </div>
          </div>
          <div  class="noData" v-if="((imglist.lenght==0&&curnav==0||wdlist.length==0&&curnav==1||yplist.length==0&&curnav==2||splist.length==0&&curnav==3))">
            <img :src="getImageUrl('/img/base/no-data-pic.7b656e6c.svg')"  class="no-data-pic">
            <span>{{curnav==0?'暂无上传图片哦':(curnav==1?'暂无上传文件哦':(curnav==2?'暂无上传音频哦':'暂无上传视频哦'))}}</span>
          </div>
        </div>

        <!-- 图片列表或视频 -->
        <div class="tab-img" v-if="curnav==0||curnav==3">
          <div class="tab-imgs" v-for="(item,index) in (curnav==0?imglist:splist)" :key="index" >
            <img class="s-img" v-if="curnav==0" :src="getImageUrl(`/img/base/${item.pic}`)" @click="xzimgbtn(index)" mode=""></img>
            <video vv-if="curnav==3" class="s-img" :src="getImageUrl(`/img/base/${item.pic}`)"  @click="xzimgbtn(index)"/>
            <img class="s-img1" v-if="item.checks" :src="getImageUrl(`/img/base/tags_selected.741c967b.svg`)" mode=""></img>
            <span @click="scimgbtn(index)">删除</span>
          </div>
        </div>
        <!-- 文档列表 -->
        <div class="wd-list" v-if="curnav==1||curnav==2">
          <div class="wd-lists" v-for="(item,index) in (curnav==1?wdlist:yplist)" :key="index" >
            <div class="s-img"><img :src="item.checks?getImageUrl(`/img/base/wxz2.png`):getImageUrl(`/img/base/wxz1.png`)" @click="xzimgbtns(index)" mode=""></img></div>
            <div class="wd-lists1">
              <span>{{item.name}}</span>
              <span>{{item.size}}</span>
              <div class="sc-txt" @click="scimgbtns(index)">删除</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-container">
      <div @click="dialogVisible = false">取消</div>
      <div @click="btnsend">发送</div>
    </div>
  </el-dialog>
  
  <el-dialog
    title="地图位置选择"
    :visible.sync="dialogVisibleadr"
    width="800px"
    :before-close="handleClose">
    <Appmap @location-selected="handleLocationSelected" @location-selected-two="handleLocationSelectedTwo"></Appmap>
  </el-dialog>
  </div>
</template>

<script>
// @ts-nocheck
import { getImgUrl } from '@/utils/index';
import Appmap from "./components/map.vue";
export default {
  name: "HomeLive",
  components: {
    Appmap,
  },
  data() {
    return {
      // 上传文档变量区分
      curnav:1,
      dialogVisible:false,
      dialogVisibleadr:false,
      // 地图选择位置坐标
      selectedLocation: null,
      selectedLocationTwo: null,
      // 上传相关变量
      uploadList: {
        image: [],
        file: [],
        audio: [],
        video: []
      },
      uploadLoading: false,
      uploadProgress: 0,
      // 主题切换
      isDarkTheme: false,
      // 当前直播时间
      currentLiveTime: "2025-12-07 12:30:45",
      
      // 用户列表数据
      userList: [
        {
          name: "付廷红",
          phone: "跟进人：陈",
          avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=60&h=60&fit=crop",
          level: 1,
          levelText: "VIP会员"
        },
        {
          name: "王五强",
          phone: "跟进人：陈",
          avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=60&h=60&fit=crop",
          level: 2,
          levelText: "SVIP会员"
        },
        {
          name: "张三疯",
          phone: "跟进人：陈",
          avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=60&h=60&fit=crop",
          level: 3,
          levelText: "钻石会员"
        },
        {
          name: "李四娘",
          phone: "跟进人：陈",
          avatar: "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=60&h=60&fit=crop",
          level: 1,
          levelText: "VIP会员"
        },{
          name: "付廷红",
          phone: "跟进人：陈",
          avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=60&h=60&fit=crop",
          level: 1,
          levelText: "VIP会员"
        },
        {
          name: "王五强",
          phone: "跟进人：陈",
          avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=60&h=60&fit=crop",
          level: 2,
          levelText: "SVIP会员"
        },
        {
          name: "张三疯",
          phone: "跟进人：陈",
          avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=60&h=60&fit=crop",
          level: 3,
          levelText: "钻石会员"
        },
        {
          name: "李四娘",
          phone: "跟进人：陈",
          avatar: "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=60&h=60&fit=crop",
          level: 1,
          levelText: "VIP会员"
        },
        {
          name: "王五哥",
          phone: "跟进人：陈",
          avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=60&h=60&fit=crop",
          level: 2,
          levelText: "SVIP会员"
        },
        {
          name: "赵六妹",
          phone: "跟进人：陈",
          avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=60&h=60&fit=crop",
          level: 3,
          levelText: "钻石会员"
        },
        {
          name: "孙七郎",
          phone: "跟进人：陈",
          avatar: "https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?w=60&h=60&fit=crop",
          level: 1,
          levelText: "VIP会员"
        },
        {
          name: "周八姐",
          phone: "跟进人：陈",
          avatar: "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=60&h=60&fit=crop",
          level: 2,
          levelText: "SVIP会员"
        }
      ],
      
      // 讨论区消息数据
      messageList: [
        {
          username: "小A的2512",
          userTag: "[优秀学员]",
          avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=40&h=40&fit=crop",
          content: "支持！"
        },
        {
          username: "支持",
          userTag: "[青青]",
          avatar: "https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?w=40&h=40&fit=crop",
          content: "支持！"
        },
        {
          username: "用户1310598838",
          userTag: "[新手]",
          avatar: "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=40&h=40&fit=crop",
          content: "更丰富，支持建国！"
        },
        {
          username: "黄浩杰",
          userTag: "[农民代表]",
          avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=40&h=40&fit=crop",
          content: "支持！"
        },
        {
          username: "王新亮",
          userTag: "[村主任]",
          avatar: "https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?w=40&h=40&fit=crop",
          content: "支持国家乡村振兴战略实施！支持供销社改革！"
        },
        {
          username: "用户1310598838",
          userTag: "[新手]",
          avatar: "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=40&h=40&fit=crop",
          content: "支持！"
        },
        {
          username: "BBR",
          userTag: "[干部]",
          avatar: "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=40&h=40&fit=crop",
          content: "下午好！"
        },{
          username: "小A的2512",
          userTag: "[优秀学员]",
          avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=40&h=40&fit=crop",
          content: "支持！"
        },
        {
          username: "支持",
          userTag: "[青青]",
          avatar: "https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?w=40&h=40&fit=crop",
          content: "支持！"
        },
        {
          username: "用户1310598838",
          userTag: "[新手]",
          avatar: "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=40&h=40&fit=crop",
          content: "更丰富，支持建国！"
        },
        {
          username: "黄浩杰",
          userTag: "[农民代表]",
          avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=40&h=40&fit=crop",
          content: "支持！"
        },
        {
          username: "王新亮",
          userTag: "[村主任]",
          avatar: "https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?w=40&h=40&fit=crop",
          content: "支持国家乡村振兴战略实施！支持供销社改革！"
        },
        {
          username: "用户1310598838",
          userTag: "[新手]",
          avatar: "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=40&h=40&fit=crop",
          content: "支持！"
        },
        {
          username: "BBR",
          userTag: "[干部]",
          avatar: "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=40&h=40&fit=crop",
          content: "下午好！"
        }
      ],
      gshow:false,
      cur:0,
      cur1:0,
      cur2:0,
      cur3:99999999,
      cur4:0,
      behavior:'',
      belonging:'',
      zkshow:false,
      value1: false,
      value2: false,
      value3: false,
      navlist:[{
        wxicon:'/img/base/hdicon1.png',
        xzicon:'/img/base/hdicon2.png',
        name:'系统消息',
        checks:true,
      },{
        wxicon:'/img/base/hdicon3.png',
        xzicon:'/img/base/hdicon4.png',
        name:'数据',
        checks:true,
      },{
        wxicon:'/img/base/hdicon5.png',
        xzicon:'/img/base/hdicon6.png',
        name:'运营消息',
        checks:true,
      },{
        wxicon:'/img/base/hdicon7.png',
        xzicon:'/img/base/hdicon8.png',
        name:'快捷发送',
        checks:true,
      },{
        wxicon:'/img/base/hdicon9.png',
        xzicon:'/img/base/hdicon10.png',
        name:'评论审核',
        checks:true,
      },{
        wxicon:'/img/base/hdicon11.png',
        xzicon:'/img/base/hdicon12.png',
        name:'直播预告',
        checks:true,
      },{
        wxicon:'/img/base/hdicon13.png',
        xzicon:'/img/base/hdicon14.png',
        name:'优惠券',
        checks:true,
      },{
        wxicon:'/img/base/hdicon15.png',
        xzicon:'/img/base/hdicon16.png',
        name:'抽奖',
        checks:true,
      },{
        wxicon:'/img/base/hdicon17.png',
        xzicon:'/img/base/hdicon18.png',
        name:'推荐卡片',
        checks:true,
      },{
        wxicon:'/img/base/hdicon19.png',
        xzicon:'/img/base/hdicon20.png',
        name:'签到',
        checks:true,
      },{
        wxicon:'/img/base/hdicon21.png',
        xzicon:'/img/base/hdicon22.png',
        name:'投票',
        checks:true,
      },{
        wxicon:'/img/base/hdicon23.png',
        xzicon:'/img/base/hdicon24.png',
        name:'商品',
        checks:true,
      }],
			showEmoji:false,
			newEmojiList:[],
      expressionData:[
				{name: "[笑掉牙]", file: "xiaodiaoya.png"},
				{name: "[可爱]", file: "keai.png"},
				{name: "[冷酷]", file: "lengku.png"},
				{name: "[闭嘴]", file: "bizui.png"},
				{name: "[生气]", file: "shengqi.png"},
				{name: "[惊恐]", file: "jingkong.png"},
				{name: "[瞌睡]", file: "keshui.png"},
				{name: "[大笑]", file: "daxiao.png"},
				{name: "[爱心]", file: "aixin.png"},
				{name: "[坏笑]", file: "huaixiao.png"},
				{name: "[飞吻]", file: "feiwen.png"},
				{name: "[疑问]", file: "yiwen.png"},
				{name: "[开心]", file: "kaixin.png"},
				{name: "[发呆]", file: "fadai.png"},
				{name: "[流泪]", file: "liulei.png"},
				{name: "[汗颜]", file: "hanyan.png"},
				{name: "[惊悚]", file: "jingshu.png"},
				{name: "[困~]", file: "kun.png"},
				{name: "[心碎]", file: "xinsui.png"},
				{name: "[天使]", file: "tianshi.png"},
				{name: "[晕]", file: "yun.png"},
				{name: "[啊]", file: "a.png"},
				{name: "[愤怒]", file: "fennu.png"},
				{name: "[睡着]", file: "shuizhuo.png"},
				{name: "[面无表情]", file: "mianwubiaoqing.png"},
				{name: "[难过]", file: "nanguo.png"},
				{name: "[犯困]", file: "fankun.png"},
				{name: "[好吃]", file: "haochi.png"},
				{name: "[呕吐]", file: "outu.png"},
				{name: "[龇牙]", file: "ziya.png"},
				{name: "[懵比]", file: "mengbi.png"},
				{name: "[白眼]", file: "baiyan.png"},
				{name: "[饿死]", file: "esi.png"},
				{name: "[凶]", file: "xiong.png"},
				{name: "[感冒]", file: "ganmao.png"},
				{name: "[流汗]", file: "liuhan.png"},
				{name: "[笑哭]", file: "xiaoku.png"},
				{name: "[流口水]", file: "liukoushui.png"},
				{name: "[尴尬]", file: "ganga.png"},
				{name: "[惊讶]", file: "jingya.png"},
				{name: "[大惊]", file: "dajing.png"},
				{name: "[不好意思]", file: "buhaoyisi.png"},
				{name: "[大闹]", file: "danao.png"},
				{name: "[不可思议]", file: "bukesiyi.png"},
				{name: "[爱你]", file: "aini.png"},
				{name: "[红心]", file: "hongxin.png"},
				{name: "[点赞]", file: "dianzan.png"},
				{name: "[恶魔]", file: "emo.png"},
			],
      content:'',
      sedcon:'',
      // 素材库列表
      imglist:[{
        pic:'WeChat.png',
        checks:false,
      },{
        pic:'WeChat.png',
        checks:false,
      },],
      // 文档列表
      wdlist:[{
        pic:'',
        name:'新建 DOC 文档.doc',
        size:'10M',
        checks:false,
      },{
        pic:'',
        name:'新建 DOC 文档.doc',
        size:'10M',
        checks:false,
      }],
      // 音频列表
      yplist:[{
        pic:'',
        name:'cgsb.mp3',
        size:'10M',
        checks:false,
      },{
        pic:'',
        name:'cgsb.mp3',
        size:'10M',
        checks:false,
      }],
      // 视频列表
      splist:[{
         pic:'24378c7222c727247332b2e21f2998dc.mp4',
         checks:false,
      },{
         pic:'24378c7222c727247332b2e21f2998dc.mp4',
         checks:false,
      }]
    };
  },
  mounted() {
   
    // 实时更新直播时间
    this.updateLiveTime();
    // 初始化标签栏拖拽功能
    this.$nextTick(() => {
      this.initDrag();
      this.initDragr();
      this.initDrags();
    });
    var that = this;
    var arr = []
		for (var i = 0; i < that.expressionData.length; i += 300) {
			arr.push(that.expressionData.slice(i, i + 300))
		}
		console.log(arr)
		that.newEmojiList = arr
  },
  methods: {
    // 全员屏蔽
    qypbbtn(e){
      console.log(e)
    },
    // 全员禁言
    qyjybtn(e){
      console.log(e)
    },
    // 素材发送
    btnsend(){

    },
    // 素材图片选择
    xzimgbtn(idx){
      var arr = this.curnav==0?this.imglist:this.splist;
      arr[idx].checks = !arr[idx].checks;
      if(this.curnav==0){
        this.imglist = arr
      }else{
        this.splist = arr
      }
    },
    // 素材图片删除
    scimgbtn(idx){
      if(this.curnav==0){
        this.imglist.splice(idx,1);
      }else{
        this.splist.splice(idx,1);
      }
    },
    // 素材文档和音频选中
    xzimgbtns(idx){
      var arr = this.curnav==1?this.wdlist:this.yplist;
      arr[idx].checks = !arr[idx].checks;
      if(this.curnav==1){
        this.wdlist = arr
      }else{
        this.yplist = arr
      }
    },
    // 素材文档和音频删除
    scimgbtns(idx){
      if(this.curnav==1){
        this.wdlist.splice(idx,1);
      }else{
        this.yplist.splice(idx,1);
      }
    },
     // 上传文档变量区分
     tabnav(idx){
      this.curnav = idx
    },
    // 处理关闭对话框
    handleClose() {
      this.dialogVisible = false;
    },
    // 获取当前类型
    getCurrentType() {
      const types = ['image', 'file', 'audio', 'video'];
      return types[this.curnav];
    },
    // 触发文件选择对话框
    triggerFileInput(inputId) {
      const inputElement = document.getElementById(inputId);
      if (inputElement) {
        inputElement.click();
      }
    },
    // 格式化文件大小
    formatFileSize(size) {
      if (size < 1024) {
        return size + ' B';
      } else if (size < 1024 * 1024) {
        return (size / 1024).toFixed(2) + ' KB';
      } else if (size < 1024 * 1024 * 1024) {
        return (size / (1024 * 1024)).toFixed(2) + ' MB';
      } else {
        return (size / (1024 * 1024 * 1024)).toFixed(2) + ' GB';
      }
    },
    // 处理地图位置选择
    handleLocationSelected(coords) {
      this.selectedLocation = coords;
      console.log('确认选择 - 位置坐标:', coords);
      // 这里可以添加其他逻辑，比如显示位置信息等
    },
    // 处理地图位置选择二
    handleLocationSelectedTwo(coords) {
      this.selectedLocationTwo = coords;
      console.log('确认选择二 - 位置坐标:', coords);
      // 这里可以添加其他逻辑，比如显示位置信息等
    },
    // 上传文件处理
    handleFileChange(event, type) {
      console.log('111')
      const file = event.target.files[0];
      if (!file) return;
      
      // 验证文件类型和大小
      const validation = this.validateFile(file, type);
      if (!validation.isValid) {
        this.$message.error(validation.message);
        return;
      }
      
      // 如果是音频或视频文件，计算时长
      if (type === 'audio' || type === 'video') {
        this.getMediaDuration(file).then(duration => {
          // 将时长添加到file对象中
          file.duration = duration;
          this.uploadFile(file, type);
        }).catch(error => {
          console.error('计算媒体时长失败:', error);
          this.$message.error('计算媒体时长失败');
        });
      } else {
        this.uploadFile(file, type);
      }
      
      // 重置input
      event.target.value = '';
    },
    // 计算媒体文件时长
    getMediaDuration(file) {
      return new Promise((resolve, reject) => {
        if (!file || !file.type) {
          reject('无效的文件');
          return;
        }
        
        // 根据文件类型选择使用Audio或Video元素
        const mediaElement = file.type.startsWith('audio/') 
          ? new Audio() 
          : document.createElement('video');
        
        // 创建文件URL
        const objectUrl = URL.createObjectURL(file);
        
        // 监听加载完成事件
        mediaElement.onloadedmetadata = () => {
          // 获取时长（秒）
          const duration = mediaElement.duration;
          
          // 释放文件URL
          URL.revokeObjectURL(objectUrl);
          
          // 解析时长信息
          const hours = Math.floor(duration / 3600);
          const minutes = Math.floor((duration % 3600) / 60);
          const seconds = Math.floor(duration % 60);
          
          // 返回时长信息
          resolve({
            totalSeconds: duration,
            formatted: `${hours > 0 ? hours + ':' : ''}${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`,
            hours, minutes, seconds
          });
        };
        
        // 监听错误事件
        mediaElement.onerror = () => {
          URL.revokeObjectURL(objectUrl);
          reject('无法解析媒体文件');
        };
        
        // 设置媒体源
        mediaElement.src = objectUrl;
      });
    },
    // 验证文件
    validateFile(file, type) {
      const fileTypes = {
        image: /(png|jpg|jpeg|gif)$/i,
        file: /(ppt|pptx|pdf|xls|xlsx|doc|docx)$/i,
        audio: /(mp3)$/i,
        video: /(mp4|avi|mov|wmv)$/i
      };
      
      const maxSizes = {
        image: 10 * 1024 * 1024, // 10MB
        file: 20 * 1024 * 1024, // 20MB
        audio: 50 * 1024 * 1024, // 50MB
        video: 1024 * 1024 * 1024 // 1GB
      };
      
      if (!fileTypes[type].test(file.name.split('.').pop())) {
        return {
          isValid: false,
          message: `不支持该文件类型，请上传正确格式的文件`
        };
      }
      
      if (file.size > maxSizes[type]) {
        return {
          isValid: false,
          message: `文件大小超过限制，最大支持${maxSizes[type] / (1024 * 1024)}MB`
        };
      }
      
      return { isValid: true };
    },
    // 上传文件
    uploadFile(file, type) {
      this.uploadLoading = true;
      this.uploadProgress = 0;
      
      // 获取上传文件的名称和类型
      const fileName = file.name;
      const fileType = file.type;
      
      // 准备文件信息
      const fileInfo = {
        name: fileName,
        type: fileType,
        size: file.size,
        formattedSize: this.formatFileSize(file.size)
      };
      
      // 如果是音频或视频文件，添加时长信息
      if (file.duration) {
        fileInfo.duration = file.duration;
      }
      
      console.log('上传文件信息:', fileInfo);
      
      const formData = new FormData();
      formData.append('file', file);
      // 可以将文件名和类型添加到FormData中，方便后端处理
      formData.append('fileName', fileName);
      formData.append('fileType', fileType);
      
      console.log('FormData内容:', formData);
      
      // 这里应该替换为实际的上传接口
      const uploadUrl = '/api/upload/' + type;
      
      // 使用axios发送请求
      this.$http.post(uploadUrl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (progressEvent) => {
          if (progressEvent.lengthComputable) {
            this.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          }
        }
      })
      .then(response => {
        // 上传成功处理
        this.$message.success('文件上传成功');
        
        // 添加到上传列表
        const uploadedFile = {
          id: response.data.id || Date.now(), // 临时ID，实际应该从后端获取
          name: file.name,
          type: type,
          size: file.size,
          url: response.data.url || '#', // 临时URL，实际应该从后端获取
          uploadTime: new Date().toLocaleString()
        };
        
        // 如果是音频或视频文件，添加时长信息
        if (file.duration) {
          uploadedFile.duration = file.duration;
        }
        
        this.uploadList[type].push(uploadedFile);
        
        // 将文件添加到编辑器
        this.addFileToEditor(uploadedFile);
        
        this.uploadLoading = false;
      })
      .catch(error => {
        // 上传失败处理
        this.$message.error('文件上传失败');
        console.error('Upload error:', error);
        this.uploadLoading = false;
      });
    },
    // 将文件添加到编辑器
    addFileToEditor(file) {
      if (!this.$refs.editor) return;
      
      let fileHtml = '';
      
      switch(file.type) {
        case 'image':
          fileHtml = `<img src="${file.url}" alt="${file.name}" class="uploaded-image" style="max-width: 200px; max-height: 200px; margin: 5px;">`;
          break;
        case 'file':
          fileHtml = `<div class="uploaded-file" style="padding: 5px; border: 1px solid #ddd; margin: 5px 0; display: inline-block;">
                        <a href="${file.url}" target="_blank" style="text-decoration: none; color: #409EFF;">
                          <span class="file-icon">📄</span>
                          <span class="file-name">${file.name}</span>
                        </a>
                      </div>`;
          break;
        case 'audio':
          fileHtml = `<audio controls src="${file.url}" style="margin: 5px;">您的浏览器不支持音频播放</audio>`;
          break;
        case 'video':
          fileHtml = `<video controls src="${file.url}" style="max-width: 300px; max-height: 200px; margin: 5px;">您的浏览器不支持视频播放</video>`;
          break;
      }
      
      // 将文件HTML添加到编辑器
      if (fileHtml) {
        // 获取当前编辑器内容
        const currentContent = this.$refs.editor.innerHTML;
        
        // 如果编辑器为空，直接设置内容，否则添加到现有内容后
        if (currentContent === '' || currentContent === '<br>' || currentContent === '&nbsp;') {
          this.$refs.editor.innerHTML = fileHtml;
        } else {
          // 在当前光标位置插入内容
          const selection = window.getSelection();
          const range = selection.getRangeAt(0);
          const frag = document.createDocumentFragment();
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = fileHtml;
          
          while (tempDiv.firstChild) {
            frag.appendChild(tempDiv.firstChild);
          }
          
          range.deleteContents();
          range.insertNode(frag);
          
          // 将光标移动到插入内容的末尾
          range.collapse(false);
          selection.removeAllRanges();
          selection.addRange(range);
        }
        
        // 更新sedcon和content变量
        this.syncContent();
      }
    },
    // 删除上传的文件
    deleteUploadedFile(type, index) {
      const file = this.uploadList[type][index];
      
      // 这里应该替换为实际的删除接口
      const deleteUrl = '/api/upload/' + type + '/' + file.id;
      
      this.$http.delete(deleteUrl)
      .then(response => {
        this.$message.success('文件删除成功');
        this.uploadList[type].splice(index, 1);
      })
      .catch(error => {
        this.$message.error('文件删除失败');
        console.error('Delete error:', error);
      });
    },
    // 下载文件
    downloadFile(file) {
      // 这里应该替换为实际的下载逻辑
      window.open(file.url, '_blank');
    },
    // 发消息处理
    Processing(message){
			var that = this;
			// var message = 'ad123456[笑掉牙][可爱]哈喽https://cdb.xinwangliu.cn[]'
			message = that.parseUrl(message);
			// 处理表情
			var reg = /\[(.+?)\]/g; // [] 中括号
			var reg_match = message.match(reg);
			console.log(reg_match)
			if (reg_match) {
				this.meontype = 1
				for (let i in reg_match) {
					var emoji_item = that.find_emoji(reg_match[i]);
					message = message.replace(emoji_item.name, that.build_chat_img(emoji_item.file, '', 'emoji'));
				}
			}else{
				this.meontype = 0
			}
      this.sedcon = message
			console.log(message)
		},
    // 查找表情
		find_emoji: function(emoji_title) {
			for (let i in this.expressionData) {
				if (this.expressionData[i].name == emoji_title) {
					return this.expressionData[i];
				}
			}
			return false;
		},
    handleInput(e) {
      // 获取编辑器的实际内容
      const editorContent = this.$refs.editor.innerHTML;
      
      // 检查是否完全没有数据
      if (editorContent === '' || editorContent === '<br>' || editorContent === '&nbsp;') {
        this.content = '';
        this.sedcon = '';
      } else {
        // 更新content变量
        this.content = this.$refs.editor.textContent || '';
      }
      console.log('当前内容:', this.content);
      console.log('当前sedcon:', this.sedcon);
    },
    syncContent() {
      // 获取编辑器的实际内容
      const editorContent = this.$refs.editor.innerHTML;
      
      // 检查是否完全没有数据
      if (editorContent === '' || editorContent === '<br>' || editorContent === '&nbsp;') {
        this.content = '';
        this.sedcon = '';
      } else {
        // 更新content变量
        this.content = this.$refs.editor.textContent || '';
      }
      console.log('syncContent - 当前内容:', this.content);
      console.log('syncContent - 当前sedcon:', this.sedcon);
    },
		// 表情转图片
		build_chat_img: function(filename, facename, class_name = 'emoji') {
			var protocol = 'https://';
			if (class_name == 'emoji') {
				return '<img class="emoji" style="width:25px;height:25px;margin:0px 2px" src="' + this.getImageUrl(`/emoji/${filename}`)+'" />';
			} else {
				return '<img class="' + class_name + '" src="' + filename + '" />';
			}
		},
		// 处理链接
		parseUrl: function(data) {
			var reg = new RegExp('(https?:\/\/)([0-9a-z.]+)([\?0-9a-z&=]+)?(#[0-9-a-z]+)?', 'g');
			return data.replace(reg, '<a target="_blank" title="$&" class="link" href="$&">$&</a>');
		},
		// 点击表情
		onEmoji(item) {
			this.content += item.name;
      this.showEmoji = false;
      this.Processing(this.content)
      console.log(this.content)
		},
    // 或者在方法中使用
    getImageUrl(path) {
      return getImgUrl(path);
    },
    // 更新直播时间
    updateLiveTime() {
      setInterval(() => {
        const now = new Date();
        this.currentLiveTime = now.toLocaleString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        });
      }, 1000);
    },
    handleEnter(idx) {
      this.cur3 = idx;
      console.log(idx);
      // 执行进入逻辑（如显示菜单）
    },
    handleLeave(idx) {
      this.cur3 = idx;
      console.log(idx);
      // 执行离开逻辑（如隐藏菜单）
    },
    // 发送操作事件
    handleCommands6(command) {
      var arr = command
      console.log(arr)
    },
    // 右侧用户更多点击事件
    handleCommands5(command) {
      var arr = command.split(',')
      console.log(arr)
    },
    // 左侧用户更多点击事件
    handleCommands4(command) {
      var arr = command.split(',')
      console.log(arr)
    },
    // 用户状态查询
    handleCommand(command) {
      console.log(command)
    },
    // 全部跟进
    handleCommands1(command) {
      console.log(command)
      this.belonging = command
    },
    // 用户归属
    handleCommands2(command) {
      console.log(command)
      this.behavior = command
    },
    // 操作标签
    handleCommands3(command) {
      console.log(command)
    },
    // 左侧tab切换
    swidths1(cur){
      this.cur1 = cur;
    },
    // 左侧tab切换
    swidths(cur){
      this.cur = cur;
      // 滚动到当前选中的标签位置
      this.scrollToTab(cur);
    },
    // 拖拽相关方法
    initDrag() {
      const tabUl = this.$refs.tabUl;
      if (!tabUl) return;
      
      let isDragging = false;
      let startX = 0;
      let startScrollLeft = 0;
      
      // 鼠标按下事件
      tabUl.addEventListener('mousedown', (e) => {
        isDragging = true;
        startX = e.pageX - tabUl.offsetLeft;
        startScrollLeft = tabUl.scrollLeft;
        // 添加样式指示拖拽状态
        tabUl.style.cursor = 'grabbing';
      });
      
      // 鼠标移动事件
      tabUl.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - tabUl.offsetLeft;
        const walk = (x - startX) * 2; // 拖拽速度倍率
        tabUl.scrollLeft = startScrollLeft - walk;
      });
      
      // 鼠标释放事件
      tabUl.addEventListener('mouseup', () => {
        isDragging = false;
        tabUl.style.cursor = 'grab';
      });
      
      // 鼠标离开事件
      tabUl.addEventListener('mouseleave', () => {
        isDragging = false;
        tabUl.style.cursor = 'grab';
      });
    },
    // 向左滑动一个标签位置
    scrollLeft() {
      if (this.$refs.tabUl) {
        const tabLi = this.$refs.tabUl.querySelector('li');
        if (tabLi) {
          const tabWidth = tabLi.offsetWidth + 24; // 标签宽度 + 左右padding(12px*2)
          this.$refs.tabUl.scrollLeft -= tabWidth;
        }
      }
    },
    // 向右滑动一个标签位置
    scrollRight() {
      if (this.$refs.tabUl) {
        const tabLi = this.$refs.tabUl.querySelector('li');
        if (tabLi) {
          const tabWidth = tabLi.offsetWidth + 24; // 标签宽度 + 左右padding(12px*2)
          this.$refs.tabUl.scrollLeft += tabWidth;
        }
      }
    },
    // 滚动到指定标签位置
    scrollToTab(index) {
        console.log(index)
      if (this.$refs.tabUl) {
        const tabItems = this.$refs.tabUl.querySelectorAll('li');
        if (tabItems[index]) {
          const tabItem = tabItems[index];
          const container = this.$refs.tabUl;
          const containerWidth = container.offsetWidth;
          const tabLeft = tabItem.offsetLeft;
          const tabWidth = tabItem.offsetWidth;
          
          // 计算滚动位置，使选中的标签居中显示
          const scrollPosition = tabLeft - (containerWidth - tabWidth) / 2;
          console.log(scrollPosition)
          container.scrollLeft = scrollPosition;
        }
      }
    },
    
    // 左侧tab切换
    swidths2(cur){
      this.cur2 = cur;
      // 滚动到当前选中的标签位置
      this.scrollToTabr(cur);
    },
    // 拖拽相关方法
    initDragr() {
      const tabUl = this.$refs.tabUlr;
      if (!tabUl) return;
      
      let isDragging = false;
      let startX = 0;
      let startScrollLeft = 0;
      
      // 鼠标按下事件
      tabUl.addEventListener('mousedown', (e) => {
        isDragging = true;
        startX = e.pageX - tabUl.offsetLeft;
        startScrollLeft = tabUl.scrollLeft;
        // 添加样式指示拖拽状态
        tabUl.style.cursor = 'grabbing';
      });
      
      // 鼠标移动事件
      tabUl.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - tabUl.offsetLeft;
        const walk = (x - startX) * 2; // 拖拽速度倍率
        tabUl.scrollLeft = startScrollLeft - walk;
      });
      
      // 鼠标释放事件
      tabUl.addEventListener('mouseup', () => {
        isDragging = false;
        tabUl.style.cursor = 'grab';
      });
      
      // 鼠标离开事件
      tabUl.addEventListener('mouseleave', () => {
        isDragging = false;
        tabUl.style.cursor = 'grab';
      });
    },
    // 向左滑动一个标签位置
    scrollLeftr() {
      if (this.$refs.tabUlr) {
        const tabLi = this.$refs.tabUlr.querySelector('li');
        if (tabLi) {
          const tabWidth = tabLi.offsetWidth + 24; // 标签宽度 + 左右padding(12px*2)
          this.$refs.tabUlr.scrollLeft -= tabWidth;
        }
      }
    },
    // 向右滑动一个标签位置
    scrollRightr() {
      if (this.$refs.tabUlr) {
        const tabLi = this.$refs.tabUlr.querySelector('li');
        if (tabLi) {
          const tabWidth = tabLi.offsetWidth + 24; // 标签宽度 + 左右padding(12px*2)
          this.$refs.tabUlr.scrollLeft += tabWidth;
        }
      }
    },
    // 滚动到指定标签位置
    scrollToTabr(index) {
        console.log(index)
      if (this.$refs.tabUlr) {
        const tabItems = this.$refs.tabUlr.querySelectorAll('li');
        if (tabItems[index]) {
          const tabItem = tabItems[index];
          const container = this.$refs.tabUlr;
          const containerWidth = container.offsetWidth;
          const tabLeft = tabItem.offsetLeft;
          const tabWidth = tabItem.offsetWidth;
          
          // 计算滚动位置，使选中的标签居中显示
          const scrollPosition = index==0?0:60*index;
          console.log(scrollPosition)
          container.scrollLeft = scrollPosition;
        }
      }
    },
    swidths3(cur){
      this.cur4 = cur;
      // 滚动到当前选中的标签位置
      this.scrollToTabs(cur);
    },
    swidths4(cur){
      this.cur5 = cur;
      // 创建新数组避免直接修改原数组
      const newNavlist = this.navlist
      // 切换当前点击项的状态
      newNavlist[cur].checks = !newNavlist[cur].checks;
      // 响应式更新数组
      this.navlist = newNavlist;
      

      console.log('当前选中项:', this.navlist[cur].name);
      console.log('状态已更新为:', this.navlist[cur].checks);
    },
    // 拖拽相关方法
    initDrags() {
      const tabUl = this.$refs.tabUls;
      if (!tabUl) return;
      
      let isDragging = false;
      let startX = 0;
      let startScrollLeft = 0;
      
      // 鼠标按下事件
      tabUl.addEventListener('mousedown', (e) => {
        isDragging = true;
        startX = e.pageX - tabUl.offsetLeft;
        startScrollLeft = tabUl.scrollLeft;
        // 添加样式指示拖拽状态
        tabUl.style.cursor = 'grabbing';
      });
      
      // 鼠标移动事件
      tabUl.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - tabUl.offsetLeft;
        const walk = (x - startX) * 2; // 拖拽速度倍率
        tabUl.scrollLeft = startScrollLeft - walk;
      });
      
      // 鼠标释放事件
      tabUl.addEventListener('mouseup', () => {
        isDragging = false;
        tabUl.style.cursor = 'grab';
      });
      
      // 鼠标离开事件
      tabUl.addEventListener('mouseleave', () => {
        isDragging = false;
        tabUl.style.cursor = 'grab';
      });
    },
    // 向左滑动一个标签位置
    scrollLefts() {
      if (this.$refs.tabUls) {
        const tabLi = this.$refs.tabUls.querySelector('li');
        if (tabLi) {
          const tabWidth = tabLi.offsetWidth + 24; // 标签宽度 + 左右padding(12px*2)
          this.$refs.tabUls.scrollLeft -= tabWidth;
        }
      }
    },
    // 向右滑动一个标签位置
    scrollRights() {
      if (this.$refs.tabUls) {
        const tabLi = this.$refs.tabUls.querySelector('li');
        if (tabLi) {
          const tabWidth = tabLi.offsetWidth + 24; // 标签宽度 + 左右padding(12px*2)
          this.$refs.tabUls.scrollLeft += tabWidth;
        }
      }
    },
    // 滚动到指定标签位置
    scrollToTabs(index) {
        console.log(index)
      if (this.$refs.tabUls) {
        const tabItems = this.$refs.tabUls.querySelectorAll('li');
        if (tabItems[index]) {
          const tabItem = tabItems[index];
          const container = this.$refs.tabUls;
          const containerWidth = container.offsetWidth;
          const tabLeft = tabItem.offsetLeft;
          const tabWidth = tabItem.offsetWidth;
          
          // 计算滚动位置，使选中的标签居中显示
          const scrollPosition =  index==0?0:60*index;
          console.log(scrollPosition)
          container.scrollLeft = scrollPosition;
        }
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.wd-list{
   width: 100%;
  height: 271px;
  overflow-y: auto;
  margin-top: 10px;
  box-sizing: border-box;
  padding-right: 16px;
  .wd-lists{
    width: 100%;
    height: 62px;
    margin-bottom: 20px;
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    .s-img{
      width: 40px;
      margin-right: 10px;
      display: inline-flex;
      align-items: center;
      cursor: pointer;
      img{
        width: 24px;
        height: auto;
      }
    }
    .wd-lists1{
      position: relative;
      width: 408px;
      height: 62px;
      padding: 0 16px;
      background-color: #f5f7fa;
      border-radius: 4px;
      height: 62px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      box-sizing: border-box;
      padding: 10px;
      .sc-txt{
        width: auto;
        height: 22px;
        background: red;
        position: absolute;
        top: 0px;
        right: 0px;
        line-height: 22px;
        padding: 0px 10px;
        font-size: 14px;
        color: #fff;
        cursor: pointer;
      }
      span{
        display: inline-block;
        width: 100%;
        height: auto;
        max-width: 293px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        line-height: 20px;
        text-align: left;
      }
    }
  }
}
.bottom-container{
      display: -webkit-flex;
      display: flex;
      -webkit-align-items: center;
      align-items: center;
      padding-right: 24px;
      -webkit-justify-content: flex-end;
      justify-content: flex-end;
      height: 56px;
      border-radius: 0 0 4px 4px;
      background-color: #fafbfc;
      border-top: 1px solid #eee;
      div:nth-child(1){
        width: 72px;
        line-height: 32px;
        border-radius: 4px;
        border: 1px solid #eee;
        outline: none;
        cursor: pointer;
      }
      div:nth-child(2){
        width: 72px;
        line-height: 32px;
        border-radius: 4px;
        margin-left: 16px;
        color: #fff;
        background-color: #2a75ed;
        outline: none;
        cursor: pointer;
      }
}
  .tab-img{
    width: 100%;
    height: 271px;
    overflow-y: auto;
    margin-top: 10px;
    box-sizing: border-box;
    padding-right: 16px;
    .tab-imgs{
      position: relative;
      width: 80px;
      height: 80px;
      margin-right: 12px;
      margin-bottom: 16px;
      font-size: 0;
      border: 1px solid #eee;
      box-sizing: border-box;
      float: left;
      cursor: pointer;
      .s-img{
        width: 100%;
        height: 100%;
      }
      .s-img1{
        width: 22px;
        height: 22px;
        position: absolute;
        top: 0px;
        right: 0px;
      }
      span{
        width: 100%;
        height: 25px;
        font-size: 14px;
        color: #fff;
        background: rgba(0, 0, 0, 0.7);
        position: absolute;
        left: 0px;
        bottom: 0px;
        display: none;
        text-align: center;
        line-height: 25px;
      }
      &:hover>span{
        display: inline-block;
      }
    }
    div:nth-child(5n){
      margin-right: 0px !important;
    }
  }
  .middle-container{
    width: 100%;
    height: 368px;
    border-top: 1px solid #eee;
    display: inline-flex;
    .middle-container-right{
      width: 464px;
      margin-left: 16px;
      overflow-y: auto;
    
      .uploaded-list-container {
          margin-top: 20px;
          max-height: 300px;
          overflow-y: auto;
          
          .noData{
              display: -webkit-flex;
              display: flex;
              -webkit-align-items: center;
              align-items: center;
              -webkit-justify-content: center;
              justify-content: center;
              -webkit-flex-direction: column;
              flex-direction: column;
              height: 320px;
              color: #b2b2b2;
              color: #333;
              font-size: 14px;
              font-weight: 400;
              font-family: PingFang SC;
              text-align: center;
              line-height: 14px;
              .no-data-pic {
                margin-bottom: 15px;
                width: 96px;
                height: 96px;
                display: block;
            }
      }
        .right-top-input {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0;
            cursor: pointer;
        }
      }
      .right-top {
          display: -webkit-flex;
          display: flex;
          -webkit-align-items: center;
          align-items: center;
          margin-top: 16px;
          .upload-label{
              position: relative;
              width: 72px;
              height: 32px;
          }
          .right-top-input[data-v-0d905e2f], .right-top-upload {
              width: 100%;
              height: 100%;
              cursor: pointer;
          }
          .right-top-input{
              position: absolute;
              top: 0;
              left: 0;
              z-index: 9;
              opacity: 0;
              font-size: 0;
          }
          .right-top-upload {
              line-height: 32px;
              text-align: center;
              border-radius: 4px;
              border: 1px solid #eee;
              outline: none;
              color: #fff;
              background-color: #2a75ed;
          }
          .right-top-desc{
            margin-left: 8px;
            color: #888;
        }
        .upload-progress {
            margin: 20px 0;
        }
        .uploaded-list {
            width: 100%;
        }
        .uploaded-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 0;
            border-bottom: 1px solid #eee;
        }
        .file-info {
            flex: 1;
        }
        .file-name {
            font-weight: 500;
            margin-right: 10px;
        }
        .file-size {
            font-size: 12px;
            color: #999;
        }
        .file-actions {
            display: flex;
            gap: 10px;
        }
        .no-data {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 40px 0;
            color: #999;
            
        }
      }
    }
    .middle-container-left{
      width: 120px;
      height: 100%;
      border-right: 1px solid #eee;
      box-sizing: border-box;
      div{
        width: 100%;
        line-height: 40px;
        text-align: center;
        color: #353535;
        border-right: 2px solid transparent;
        cursor: pointer
      }
      .actives1{
        color: #2a75ed !important;
        border-right-color: #2a75ed !important;
      }
    }
  }
  .emoji{
    width: 20px !important;
    height: 20px !important;
    margin: 0 2px;
  }
  .message-input-area {
    padding: 0.78vw;
    padding-top: 0px;
    box-sizing: border-box;
    border-top: 1px solid #f6f6f6;
    border: 1px solid #EEEEEE;
    width: 100%;
    position: relative;
    // 表情栏
	.emoji-box {
		width: 15vw;
		background-color: #fff;
		height: auto;
		border-top: 1px solid #f6f6f6;
		transition: all 0.3s ease-in-out 0s;
		padding: 10px;
    position: absolute;
    left: 0px;
    bottom: 196px;
    padding-left: 0px;
    box-shadow: 0 4px 20px 0 rgba(51, 51, 51, .12156862745098039);
    .emoji-boxs{
      width: 100%;
      height: 180px;
      overflow-y: auto;
    }
		.emoji-img {
			width: 25px;
			height: 25px;
			display: inline-block;
			margin: 5px;
      cursor: pointer;
      img{
        	width: 25px;
			    height: 25px;
      }
		}
	}
    .message-filters {
      display: flex;
      flex-direction: row;
      width: 100%;
      justify-content: space-between;
      align-items: center;
      font-size: 12px;
      color: #666;
      box-sizing: border-box;
      padding:0.5vh 0vw;
      cursor: pointer;
      .filter-items{
        padding: 0px 1vw;
        height: 30px;
        background: #2476FD;
        text-align: center !important;
        line-height: 30px;
        display: inline-flex;
        color: #fff !important;
      }
      .filter-item {
        display: flex;
        align-items: center;
        gap: 8px;
        cursor: pointer;
        
        input[type="checkbox"]:checked + .switch {
          background-color: #4CAF50;
          
          &::before {
            left: 17px;
          }
        }
      }
    }
    .shopro-send-pre:empty::before {  
      content: attr(aria-placeholder);  
      color: #999;  
    }  
      
    .shopro-send-pre:focus::before {  
      content: none;  
    }
    .shopro-send-pre{
      width: 100%;
      border: none !important;
      outline: none;
      background: none;
      height: 10.2vh;
      padding: 0;
      text-align: left;
      overflow-y: auto;
    }
    .top-message{
      width: 100%;
      height: 5.1vh;
      display: inline-flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      position: relative;
      .message-left{
        img{
          width: 1.56vw;
          height: auto;
          margin-right: 1vw;
          cursor: pointer;
        }
      }
      .message-btn{
          width: auto;
          height: 5.1vh;
          display: inline-flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 0.8vw;
          color: #999999;
          cursor: pointer;
          position: relative;
          img{
            width: 1.56vw;
            height: auto;
          }
      }
    }
  }

.listitem1>div:nth-child(3n){
  margin-right: 0px !important;
}
.glist{
  width: 480px;
  height: auto;
  background: #FFFFFF;
  box-shadow: 0px 0px 10px 0px rgba(153,153,153,0.2);
  border-radius: 10px;
  padding:10px 20px;
  box-sizing: border-box;
  position: absolute;
  right: 0px;
  top: 45px;
  .listitem{
    width: 100%;
    height: auto;
    display: table;
    .listitem1{
      width: 100%;
      height: auto;
      display: table;
      .listitem2{
        width: 140px;
        height: 40px;
        background: #F6F6F6;
        border-radius: 4px;
        float: left;
        margin-right: 10px;
        margin-bottom: 10px;
        box-sizing: border-box;
        padding: 10px;
        display: inline-flex;
        justify-content: space-between;
        flex-direction: row;
        align-items: center;
        cursor: pointer;
        div{
          width: auto;
          display: inline-flex;
          justify-content: center;
          img{
            width: auto;
            height: 18px;
            margin-right: 5px;
          }
        }
        img{
          width: auto;
          height: 21px;
          margin-right: 5px;
        }
      }
      div:last-child{
        margin-right: 0px;
      }
    }
    .spans{
      width: 100%;
      height: auto;
      display: inline-flex;
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 16px;
      color: #111111;
      line-height: 30px;
    }
  }
}
.g_btn{
  width: 5.2vw;
  height: auto;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  position: relative;
  img{
    width: auto;
    height: 20px;
    margin-right: 5px
  }
  span{
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    color: #111111;
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    white-space: nowrap;
  }
}
.titme{
  widows: 100%;
  text-align: center;
  line-height: 25px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 0.8vw;
  color: #999999;
  margin: 5px 0px;
}
/* 右侧讨论区 */
.discussion-panel {
  width: 20.8vw;
  background-color: #fff;
  border-left: 10px solid #f6f6f6;
  display: flex;
  flex-direction: column;
  
  .panel-header {
    padding: 0px 1.04vw;
    box-sizing: border-box;
    border-bottom: 1px solid #f6f6f6;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    display: inline-flex;
    .panel-title {
      font-size: 16px;
      font-weight: bold;
      color: #333;
    }
    div{
      width: 2.34vw;
      height: 2.34vw;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      img{
        width:1vw;
        height: auto;
        margin-left: 5px;
      }
    }
  }
  
  .discussion-header {
    border-bottom: 1px solid #f6f6f6;
    
  .panel-headers {
    box-sizing: border-box;
    font-size: 14px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 56px;
    overflow-x: scroll;
    .panel-item1{
      width: 32px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      img{
        width: 6px;
        height: 12px;
      }
    }
    .panel-item2{
      width: 302px;
      overflow: hidden;
      ul{
        width: auto;
        list-style: none;
        display: flex;
        overflow-x: auto;
        white-space: nowrap;
        -webkit-overflow-scrolling: touch;
        /* 隐藏滚动条 */
        &::-webkit-scrollbar {
          display: none;
        }
        -ms-overflow-style: none;
        scrollbar-width: none;
        li{
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 16px;
          color: #111111;
          padding: 0px 12px;
          cursor: pointer;
          white-space: nowrap;
        }
        .actvie{
          color: #2476FD;
        }
      }
    }
    .panel-item3{
      width: 32px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      img{
        width: 6px;
        height: 12px;
      }
    }
  }
    .discussion-tabs {
      display: flex;
      gap: 15px;
      margin-bottom: 15px;
      font-size: 14px;
      
      .tab {
        padding: 5px 10px;
        cursor: pointer;
        color: #666;
        
        &.active {
          color: #ff4444;
          font-weight: bold;
          border-bottom: 2px solid #ff4444;
        }
      }
    }
    
    .message-filters {
      display: flex;
      flex-direction: row;
      width: 100%;
      justify-content: space-between;
      align-items: center;
      font-size: 12px;
      color: #666;
      box-sizing: border-box;
      padding: 1vh 1.04vw;
      .filter-item {
        display: flex;
        align-items: center;
        gap: 8px;
        cursor: pointer;
        
        .switch {
          width: 30px;
          height: 15px;
          background-color: #ddd;
          border-radius: 10px;
          position: relative;
          
          &::before {
            content: '';
            position: absolute;
            top: 2px;
            left: 2px;
            width: 11px;
            height: 11px;
            background-color: white;
            border-radius: 50%;
            transition: all 0.3s;
          }
        }
        
        input[type="checkbox"]:checked + .switch {
          background-color: #4CAF50;
          
          &::before {
            left: 17px;
          }
        }
      }
    }
  }
  
  .message-list {
    flex: 1;
    overflow-y: auto;
    padding: 15px;
    .message-lists{
      width: 100%;
      .conright{
        width: 100%;
        display: flex;
        height: 30px;
        align-items: center;
        box-sizing: border-box;
        padding-left: 3vw;
        span{
          margin-right: 0.8vw;
          font-size: 0.8vw;
        }
        span:nth-child(1){
          color: #2476FD;
        }
        span:nth-child(2){
          color: #999999;
        }
        span:nth-child(3){
          color: #FF3333;
        }
        span:nth-child(4){
          color: #FF3333;
        }
      }
      .message-item {
        display: flex;
        gap: 10px;
        padding-bottom:5px;
        cursor: pointer;
        .message-avatar {
          img {
            width: 2.6vw;
            height: 2.6vw;
            border-radius: 50%;
            object-fit: cover;
          }
        }
        
        .message-content {
          width: 13.95vw;
          .message-user-info {
            display: flex;
            align-items: center;
            gap: 8px;
            margin-bottom: 5px;
            
            .message-username {
              font-size: 12px;
              font-weight: bold;
              color: #333;
            }
            
            .message-user-tag {
              font-size: 10px;
              color: #666;
            }
          }
          
          .message-text {
            font-size: 13px;
            color: #333;
            line-height: 22px;
            white-space: pre-wrap;
            width: auto;
            display: table;
            height: auto;
            background: #EEEEEE;
            border-radius: 0px 10px 10px 10px;
            padding: 5px 10px;
          }
        }
      }
    }
    
  }
  
}
/* 左侧用户列表 */
.mores{
  width: 1.04vw;
  height:auto;
}
.el-dropdown-links{
  border-radius: 5px;
  border: 1px solid #EEEEEE;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 4.08vh;
  cursor: pointer;
}
.el-dropdown-links1{
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 4.08vh;
  cursor: pointer;
}
.el-dropdown-links2{
  color: rgba(36, 118, 253, 1) !important;
  cursor: pointer;
}
ul{
  padding: 0px !important;
}
.user-list-panel {
  width:20.8vw;
  background-color: #fff;
  border-right: 10px solid #f6f6f6;
  display: flex;
  flex-direction: column;
  
  .panel-header {
    padding:0px 15px;
    box-sizing: border-box;
    border-bottom: 1px solid #f6f6f6;
    font-size: 14px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 56px;
    overflow-x: scroll;
    .panel-item1{
      width: 32px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      img{
        width: 6px;
        height: 12px;
      }
    }
    .panel-item2{
      width: 302px;
      overflow: hidden;
      ul{
        width: auto;
        list-style: none;
        display: flex;
        overflow-x: auto;
        white-space: nowrap;
        -webkit-overflow-scrolling: touch;
        /* 隐藏滚动条 */
        &::-webkit-scrollbar {
          display: none;
        }
        -ms-overflow-style: none;
        scrollbar-width: none;
        li{
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 16px;
          color: #111111;
          padding: 0px 12px;
          cursor: pointer;
          white-space: nowrap;
        }
        .actvie{
          color: #2476FD;
        }
      }
    }
    .panel-item3{
      width: 32px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      img{
        width: 6px;
        height: 12px;
      }
    }
  }
  
  .search-box {
    padding:0px 1.25vw;
    box-sizing: border-box;
    border-bottom: 1px solid #f6f6f6;
    .search-cr{
      width: 100%;
      height: 4.08vh;
      display: inline-flex;
      justify-content: space-between;
      align-items: center;
      flex-direction: row;
      margin-bottom: 1vh;
      img{
        width: 25px;
        height: 25px;
        cursor: pointer;
        float: right;
      }
      .sear-left{
        
      display: inline-flex;
      justify-content: space-between;
      align-items: center;
      flex-direction: row;
        .searchit{
          width: 6.25vw;
          height: 4.08vh;
          margin-right: 0.52vw;
          .el-dropdown{
            width: 100%;
            height: 4.08vh;
          }
        }
        .i-np{
          width: 7.29vw;
            height: 4.08vh;
            margin-right: 0.52vw;
            border: 1px solid #EEEEEE;
            border-radius: 5px;
            box-sizing: border-box;
            padding: 0px 10px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: 0.83vw;
            color: #333;
        }
        input{
          outline: none;
          border: none;
          appearance: none;
          -webkit-appearance: none;
          -moz-appearance: none;
          -O-appearance: none;
        }
        .i-np:-ms-input-placeholder{
          opacity: 1;
          color: #999999;
        }
        .i-np:-webkit-input-placeholder{
          opacity: 1;
          color: #999999;
        }
        .i-np:-moz-input-placeholder{
          opacity: 1;
          color: #999999;
        }
      }
      
    }
    .searchxs{
      width: 100%;
      height: auto;
      display: flex;
      margin: 1vh 0px;
      .actvies{
        background: rgba(235, 243, 255, 1);
        color: #2476FD !important;
      }
      div{
        margin-right: 10px;
        min-width: 6vw;
        box-sizing: border-box;
        padding: 0px 20px;
        height: 30px;
        background: #F6F6F6;
        border-radius: 15px;
        cursor: pointer;
        text-align: center;
        line-height: 30px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 0.9vw;
        color: #111111;
      }
    }
  }
  
  .user-list {
    flex: 1;
    overflow-y: auto;
    padding: 10px 0.52vw;
    
    .user-item {
      display: flex;
      // align-items: center;
      padding: 10px;
      border-bottom: 1px solid #f0f0f0;
      
      &:last-child {
        border-bottom: none;
      }
    }
    
    .user-avatar {
      position: relative;
      margin-right: 0.52vw;
      
      img {
        width: 2.6vw;
        height: 2.6vw;
        border-radius: 50%;
        object-fit: cover;
      }
      
      .online-indicator {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 12px;
        height: 12px;
        background-color: #4CAF50;
        border: 2px solid white;
        border-radius: 50%;
      }
    }
    .user-infos{
      width: 13.95vw;
      .user-info {
            width: 13.95vw;
            min-width: 0;
            .user-name {
              width: 100%;
              
              font-family: Microsoft YaHei;
              font-weight: 400;
              font-size: 0.8vw;
              color: #666666;
              margin-bottom: 3px;
              text-align: left;
            }
            
            .user-phone {
              width: 100%;
              font-family: Microsoft YaHei;
              font-weight: 400;
              font-size: 0.8vw;
              color: #666666;
              text-align: left;
              margin: 5px 0px;
            }
            .user-use{
                width: auto;
                height: auto;
                font-family: Microsoft YaHei;
                font-weight: 400;
                font-size: 0.8vw;
                color: #FF934D;
                border: 1px solid #FF934D;
                display: inline-block;
                float: left;
                line-height: 2.24vh;
                padding: 0px 0.5vw;
            }
            .tabitem{
              width: 100%;
              display: inline-flex;
              margin-top: 5px;
              span{
                padding: 0px 0.5vw;
                line-height:  2.24vh;
              }
              span:nth-child(1){
                background: #FFE7E1;
                margin-right: 0.5vw;
                font-family: Microsoft YaHei;
                font-weight: 400;
                font-size: 0.65vw;
                color: #FF623B;
              }
              span:nth-child(2){
                background: #FFE7E1;
                margin-right: 0.5vw;
                font-family: Microsoft YaHei;
                font-weight: 400;
                font-size: 0.65vw;
                color: #FF623B;
              }
              span:nth-child(3){
                background: #FFF3E0;color: #ED9613;
                font-family: Microsoft YaHei;
                font-weight: 400;
                font-size: 0.65vw;
              }
            }
          }
    }
    
    
    .user-level {
      margin-right: 10px;
      
      .level-tag {
        padding: 2px 6px;
        border-radius: 10px;
        font-size: 10px;
        color: white;
        
        &.level-1 {
          background-color: #4CAF50;
        }
        
        &.level-2 {
          background-color: #2196F3;
        }
        
        &.level-3 {
          background-color: #FF9800;
        }
      }
    }
    
    .user-actions {
      color: #999;
      font-size: 16px;
      cursor: pointer;
    }
  }
}

.el-dropdown-link {
    display: inline-flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    .logoimg{
      width: 40px;
      height: 40px;
      border-radius: 40px;
      margin-right: 5px;
    }
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
/* 直播顶部信息栏 */
.live-header {
  background-color: #fff;
  border-bottom: 10px solid #f6f6f6;
  padding: 10px 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  
  .live-info {
    display: flex;
    align-items: center;
    gap: 15px;
    font-size: 14px;
    color: #333;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
    .live-right{
      display: inline-flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      img:nth-child(1){
        width: 40px;
        height: 40px;
        border-radius: 40px;
        margin-right: 5px;
      }
      img:nth-child(2){
        width: 11px;
        height: auto;
      }
    }
    .live-left{
      display: inline-flex;
      justify-content: center;
      align-items: center;
      img{
        width: 40px;
        height: 40px;
        border-radius: 40px;
        margin-right: 5px;
      }
    }
    div{

    }
  }
}
.home-live {
  width: 100%;
  height: 100vh;
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
}

/* 主题切换样式 */
.home-live.dark-theme {
  background-color: #1a1a1a;
  color: #f6f6f6;
}

/* 主题切换按钮样式 */
.theme-toggle {
  margin-left: auto;
  display: flex;
  gap: 10px;
}

.theme-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 8px 16px;
  border: none;
  border-radius: 20px;
  background-color: #f0f0f0;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.3s ease;
  color: #333;
}

.theme-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.theme-btn.active {
  background-color: #ff4444;
  color: white;
}

.theme-btn .icon {
  font-size: 14px;
}


/* 深色主题样式 */
.home-live.dark-theme .live-header {
  background-color: #2d2d2d;
  border-bottom-color: #444;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.home-live.dark-theme .live-info {
  color: #f6f6f6;
}

.home-live.dark-theme .live-status {
  color: #ff4444;
}

.home-live.dark-theme .live-time,
.home-live.dark-theme .live-title {
  color: #f6f6f6;
}

.home-live.dark-theme .live-period {
  color: #aaa;
}

.home-live.dark-theme .live-main {
  background-color: #1a1a1a;
}

.home-live.dark-theme .user-list-panel,
.home-live.dark-theme .live-video-panel,
.home-live.dark-theme .discussion-panel {
  background-color: #2d2d2d;
  border-color: #444;
}

.home-live.dark-theme .panel-header {
  background-color: #3a3a3a;
  border-bottom-color: #444;
}

.home-live.dark-theme .panel-title,
.home-live.dark-theme .online-count,
.home-live.dark-theme .total-count {
  color: #f6f6f6;
}

.home-live.dark-theme .search-input,
.home-live.dark-theme .user-type-select {
  background-color: #3a3a3a;
  border-color: #555;
  color: #f6f6f6;
}

.home-live.dark-theme .search-btn {
  background-color: #ff4444;
  color: white;
}

.home-live.dark-theme .user-item {
  border-bottom-color: #444;
}

.home-live.dark-theme .user-name,
.home-live.dark-theme .user-phone {
  color: #f6f6f6;
}

.home-live.dark-theme .video-container {
  background-color: #000;
}

.home-live.dark-theme .video-overlay {
  background: rgba(0, 0, 0, 0.7);
}

.home-live.dark-theme .video-title,
.home-live.dark-theme .video-subtitle {
  color: white;
}

.home-live.dark-theme .video-controls {
  background-color: #2d2d2d;
  border-top-color: #444;
}

.home-live.dark-theme .control-btn {
  background-color: #3a3a3a;
  color: #f6f6f6;
  border-color: #555;
}

.home-live.dark-theme .control-btn:hover {
  background-color: #4a4a4a;
  color: white;
}

.home-live.dark-theme .stats-header {
  border-bottom-color: #444;
}

.home-live.dark-theme .stats-title,
.home-live.dark-theme .stats-tabs .tab {
  color: #f6f6f6;
}

.home-live.dark-theme .stats-tabs .tab.active {
  color: #ff4444;
  border-bottom-color: #ff4444;
}

.home-live.dark-theme .time-select {
  background-color: #3a3a3a;
  border-color: #555;
  color: #f6f6f6;
}

.home-live.dark-theme .stat-card {
  background-color: #2d2d2d;
  border-color: #444;
}

.home-live.dark-theme .stat-label,
.home-live.dark-theme .stat-value {
  color: #f6f6f6;
}

.home-live.dark-theme .chart-container {
  background-color: #2d2d2d;
  border-color: #444;
}

.home-live.dark-theme .chart-title,
.home-live.dark-theme .legend-item,
.home-live.dark-theme .chart-time-range {
  color: #f6f6f6;
}

.home-live.dark-theme .discussion-header {
  background-color: #3a3a3a;
  border-bottom-color: #444;
}

.home-live.dark-theme .discussion-tabs .tab {
  color: #f6f6f6;
}

.home-live.dark-theme .discussion-tabs .tab.active {
  color: #ff4444;
  border-bottom-color: #ff4444;
}

.home-live.dark-theme .message-filters {
  color: #f6f6f6;
}

.home-live.dark-theme .message-list {
  background-color: #2d2d2d;
}

.home-live.dark-theme .message-item {
  border-bottom-color: #444;
}

.home-live.dark-theme .message-username,
.home-live.dark-theme .message-user-tag,
.home-live.dark-theme .message-text {
  color: #f6f6f6;
}

.home-live.dark-theme .message-input-area {
  background-color: #2d2d2d;
  border-top-color: #444;
}

.home-live.dark-theme .message-input {
  background-color: #3a3a3a;
  border-color: #555;
  color: #f6f6f6;
}
  .home-live.dark-theme .send-btn {
    background-color: #ff4444;
    color: white;
  }
 
  /* 直播主内容区 */
  .live-main {
  flex: 1;
  display: flex;
  overflow: hidden;
}


/* 中间直播区域 */
.live-video-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  
  .video-container {
    position: relative;
    height: 450px;
    background-color: #000;
    
    .video-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    
    .video-overlay {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 20px;
      background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
      color: white;
      
      .video-title {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 5px;
      }
      
      .video-subtitle {
        font-size: 14px;
        opacity: 0.9;
      }
    }
  }
  
  .video-controls {
    padding: 15px;
    border-bottom: 1px solid #f6f6f6;
    background-color: #fff;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    .panel-header {
      padding:0px;
      box-sizing: border-box;
      font-size: 14px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      height: 56px;
      overflow-x: scroll;
      .panel-item1{
        width: 24px;
        height: 24px;
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #EEEEEE;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        img{
          width: 6px;
          height: 12px;
        }
      }
      .panel-item2{
        width: 47vw;
        overflow: hidden;
        ul{
          width: auto;
          list-style: none;
          display: flex;
          overflow-x: auto;
          white-space: nowrap;
          -webkit-overflow-scrolling: touch;
          /* 隐藏滚动条 */
          &::-webkit-scrollbar {
            display: none;
          }
          -ms-overflow-style: none;
          scrollbar-width: none;
          li{
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #111111;
            display: inline-flex;
            align-items: center;
            padding: 0px 12px;
            cursor: pointer;
            white-space: nowrap;
            img{
              width: auto;
              height: 20px;
              margin-right: 5px;
            }
          }
          .actvie{
            color: #2476FD;
          }
        }
      }
      .panel-item3{
        width: 24px;
        height: 24px;
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #EEEEEE;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        img{
          width: 6px;
          height: 12px;
        }
      }
    }
    .control-btn {
      padding: 8px 15px;
      background-color: #fff;
      border: 1px solid #ddd;
      border-radius: 4px;
      cursor: pointer;
      font-size: 12px;
      color: #333;
      transition: all 0.3s;
      
      &:hover {
        background-color: #f0f0f0;
        border-color: #ccc;
      }
    }
  }
  
  .stats-panel {
    flex: 1;
    padding: 15px;
    overflow-y: auto;
    
    .stats-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      
      .stats-title {
        font-size: 16px;
        font-weight: bold;
        color: #333;
      }
      
      .stats-tabs {
        display: flex;
        align-items: center;
        gap: 15px;
        font-size: 14px;
        
        .tab {
          padding: 5px 10px;
          cursor: pointer;
          color: #666;
          
          &.active {
            color: #ff4444;
            font-weight: bold;
            border-bottom: 2px solid #ff4444;
          }
        }
        
        .time-select {
          padding: 5px 10px;
          border: 1px solid #ddd;
          border-radius: 4px;
          font-size: 12px;
        }
      }
    }
    
    .stats-content {
      .stats-cards {
        display: flex;
        gap: 20px;
        margin-bottom: 20px;
        
        .stat-card {
          flex: 1;
          background-color: #f8f8f8;
          padding: 20px;
          border-radius: 8px;
          text-align: center;
          
          .stat-label {
            font-size: 14px;
            color: #666;
            margin-bottom: 10px;
          }
          
          .stat-value {
            font-size: 24px;
            font-weight: bold;
            color: #333;
          }
        }
      }
      
      .stats-chart {
        background-color: #f8f8f8;
        padding: 20px;
        border-radius: 8px;
        
        .chart-placeholder {
          text-align: center;
          
          .chart-title {
            font-size: 16px;
            font-weight: bold;
            color: #333;
            margin-bottom: 15px;
          }
          
          .chart-legend {
            display: flex;
            justify-content: center;
            gap: 20px;
            margin-bottom: 15px;
            font-size: 14px;
            color: #666;
            
            .legend-item {
              display: flex;
              align-items: center;
              gap: 5px;
              
              .legend-dot {
                width: 12px;
                height: 12px;
                border-radius: 50%;
                
                &.online {
                  background-color: #4CAF50;
                }
                
                &.bandwidth {
                  background-color: #2196F3;
                }
                
                &.pv {
                  background-color: #FF9800;
                }
              }
            }
          }
          
          .chart-time-range {
            font-size: 12px;
            color: #999;
            margin-bottom: 20px;
          }
          
          .chart-simulation {
            height: 200px;
            background-color: #fff;
            border: 1px solid #f6f6f6;
            border-radius: 4px;
            position: relative;
            overflow: hidden;
            
            .chart-lines {
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              padding: 20px;
              
              .line {
                position: absolute;
                bottom: 20px;
                left: 20px;
                right: 20px;
                height: 2px;
                background-size: 100% 100%;
                
                &.line-online {
                  background-image: linear-gradient(to right, transparent, #4CAF50 10%, #4CAF50 90%, transparent);
                  height: 3px;
                  bottom: 100px;
                  
                  &::before {
                    content: '';
                    position: absolute;
                    top: -2px;
                    left: 10%;
                    right: 90%;
                    height: 6px;
                    background: linear-gradient(to right, #4CAF50, #4CAF50 80%, transparent);
                    border-radius: 3px;
                  }
                  
                  &::after {
                    content: '';
                    position: absolute;
                    top: -2px;
                    left: 10%;
                    right: 40%;
                    height: 6px;
                    background: linear-gradient(to right, transparent, #4CAF50 20%, #4CAF50 80%, transparent);
                    border-radius: 3px;
                    bottom: -50px;
                  }
                }
                
                &.line-bandwidth {
                  background-image: linear-gradient(to right, transparent, #2196F3 20%, #2196F3 80%, transparent);
                  bottom: 60px;
                }
                
                &.line-pv {
                  background-image: linear-gradient(to right, transparent, #FF9800 30%, #FF9800 70%, transparent);
                  bottom: 20px;
                }
              }
            }
          }
        }
      }
    }
  }
}

</style></script>

<style scoped>
    /deep/ .el-dialog__body {
    padding: 0 !important;
  }

  /* 或使用Vue 2.6+推荐语法 */
  ::v-deep .el-dialog__body {
    padding: 0 !important;
  }

  /* 全局样式方案（在main.js或全局CSS） */
  .el-dialog__body {
    padding: 0 !important;
  }
</style>